var selectYoutube = function () { return function (state) { return state.youtube; }; };
export default selectYoutube;
